export const ageMethod = "age nearest";
export const gateway = "https://coughlin-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/coughlin";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjb3VnaGxpbiIsIm5hbWUiOiJjb3VnaGxpbiIsImlhdCI6MTc3OTkyMzU4OSwiZXhwIjoxOTM3NzExNTg5fQ.P1K5D3alNWg1sPpNcKyN2tepEU-oyIbqoa6EMhH9UwU";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"coughlin.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_coughlin",
			brands: [
				"coughlin.link.wawanesalife.com",
			],
			broker: "coughlin",
			broker_formatted_name: "Coughlin Insurance Brokers",
			email: "crossroads@coughlin.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1170 Taylor Ave.",
				"Winnipeg",
				"MB",
				"R3M 3Z4",
			],
			map2: [
				"1570 Regent Ave. W.",
				"Winnipeg",
				"MB",
				"R2C 3B4",
			],
			map3: [
				"2188 McPhillips St.",
				"Winnipeg",
				"MB",
				"R2V 3C8",
			],
			map4: [
				"11 Vervain Dr.",
				"Rosser",
				"MB",
				"R0H 1E0",
			],
			"maps": {
				"map4": [
					"11 Vervain Dr.",
					"Rosser",
					"MB",
					"R0H 1E0",
				],
				"map3": [
					"2188 McPhillips St.",
					"Winnipeg",
					"MB",
					"R2V 3C8",
				],
				"map2": [
					"1570 Regent Ave. W.",
					"Winnipeg",
					"MB",
					"R2C 3B4",
				],
				"map1": [
					"1170 Taylor Ave.",
					"Winnipeg",
					"MB",
					"R3M 3Z4",
				],
			},
			menuPhone: "button",
			phone: "204-953-4620",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://www.coughlin.com/privacy-policy",
			themeSwitcher: "hide",
			website: "https://www.coughlin.com",
			scope: "coughlin#branding#coughlin.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "coughlin.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_coughlin",
			brands: [
				"coughlin.link.wawanesalife.com",
			],
			broker: "coughlin",
			broker_formatted_name: "Coughlin Insurance Brokers",
			email: "crossroads@coughlin.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1170 Taylor Ave.",
				"Winnipeg",
				"MB",
				"R3M 3Z4",
			],
			map2: [
				"1570 Regent Ave. W.",
				"Winnipeg",
				"MB",
				"R2C 3B4",
			],
			map3: [
				"2188 McPhillips St.",
				"Winnipeg",
				"MB",
				"R2V 3C8",
			],
			map4: [
				"11 Vervain Dr.",
				"Rosser",
				"MB",
				"R0H 1E0",
			],
			"maps": {
				"map4": [
					"11 Vervain Dr.",
					"Rosser",
					"MB",
					"R0H 1E0",
				],
				"map3": [
					"2188 McPhillips St.",
					"Winnipeg",
					"MB",
					"R2V 3C8",
				],
				"map2": [
					"1570 Regent Ave. W.",
					"Winnipeg",
					"MB",
					"R2C 3B4",
				],
				"map1": [
					"1170 Taylor Ave.",
					"Winnipeg",
					"MB",
					"R3M 3Z4",
				],
			},
			menuPhone: "button",
			phone: "204-953-4620",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			privacyLink: "https://www.coughlin.com/privacy-policy",
			themeSwitcher: "hide",
			website: "https://www.coughlin.com",
			scope: "coughlin#branding#coughlin.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "coughlin.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:13:09 GMT-0500 (Central Daylight Time)
